export function getGarageProposedDates(proposedChanges = []) {
  return proposedChanges
    .filter(
      ({ type, status, updatedBy, value }) =>
        type === 'collection-time' && status === 'proposed' && updatedBy === 'garage' && value
    )
    .map(({ value }) => value);
}

function getReviewInvites(invites) {
  return invites.filter(({ status }) => status === 'review');
}

export function getUniqueGarageProsedDates(invites) {
  const reviewInvites = getReviewInvites(invites);
  const datesProposedByGarages = reviewInvites
    .map((invitation) => getGarageProposedDates(invitation?.proposedChanges))
    .flat()
    .sort();

  const uniqueDates = [...new Set(datesProposedByGarages)];
  return uniqueDates;
}
export function shouldShowRescheduleSection(invites) {
  const hasReviewInvites = getReviewInvites(invites);

  return hasReviewInvites.length > 0;
}

export function hasGarageProposedDates({ proposedChanges }) {
  return proposedChanges?.some(
    ({ status, updatedBy, value }) => status === 'proposed' && updatedBy === 'garage' && value
  );
}

export function hasCaseManagerReviewedDates({ proposedChanges }) {
  return proposedChanges?.some(
    ({ status, updatedBy, value }) => status === 'reviewed' && updatedBy === 'case-manager' && value
  );
}

export function hasCustomerConfirmedDates({ proposedChanges }) {
  return proposedChanges?.some(
    ({ status, updatedBy, value }) => status === 'confirmed' && updatedBy === 'customer' && value
  );
}

export function hasGarageProposedProposedChanges(invites = []) {
  return getReviewInvites(invites).some(hasGarageProposedDates);
}

export function hasCaseManagerReviewedProposedChanges(invites = []) {
  return getReviewInvites(invites).some(hasCaseManagerReviewedDates);
}

export function hasCustomerConfirmedProposedChanges(invites = []) {
  return getReviewInvites(invites).some(hasCustomerConfirmedDates);
}

export function canFinaliseGarageProposal(garageInvites) {
  return (
    hasGarageProposedProposedChanges(garageInvites) &&
    !hasCaseManagerReviewedProposedChanges(garageInvites) &&
    !hasCustomerConfirmedProposedChanges(garageInvites)
  );
}

export function canFinaliseCaseManagerReviewedProposal(garageInvites) {
  return (
    hasCaseManagerReviewedProposedChanges(garageInvites) &&
    !hasCustomerConfirmedProposedChanges(garageInvites)
  );
}

export function canFinaliseCustomerConfirmedProposal(garageInvites) {
  return hasCustomerConfirmedProposedChanges(garageInvites);
}
